import * as React from "react";
import { Outlet, Route, Routes } from "react-router";
import { StatisticsByAdvancedListPanel } from "./pages/advanced/StatisticsByAdvancedListPanel";
import { StatisticsByRoutePairListPanel } from "./pages/route/StatisticsByRoutePairListPanel";
import { StatisticsBySellerListPanel } from "./pages/seller/StatisticsBySellerListPanel";
import { StatisticsTotalDetails } from "./pages/total/StatisticsTotalDetails";
import { StatisticsHeader } from "@/features/statistics/components/StatisticsHeader";
import { StatisticsByCustomerListScreen } from "./pages/customer/StatisticsByCustomerListScreen";
import { StatisticsBySalesRegionListScreen } from "./pages/sales-region/StatisticsBySalesRegionListScreen";
import { StatisticsByAgreedVolumeListPanel } from "./pages/agreed-volume/StatisticsByAgreedVolumeListPanel";
import { SearchFilterSelectorProvider } from "../search-filter/context/searchFilterSelectorContext";

const Layout = () => (
  <>
    <StatisticsHeader />
    <Outlet />
  </>
);

export const StatisticsTabRoutes: React.FC = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path={"/total"} element={<StatisticsTotalDetails />} />
      <Route
        path={"/sales-region"}
        element={<StatisticsBySalesRegionListScreen />}
      />
      <Route path={"/route"} element={<StatisticsByRoutePairListPanel />} />
      <Route path={"/seller"} element={<StatisticsBySellerListPanel />} />
      <Route path={"/customer"} element={<StatisticsByCustomerListScreen />} />
      <Route
        path={"/agreed-volume"}
        element={
          <SearchFilterSelectorProvider reducerId="statistics.statisticsByAgreedVolume">
            <StatisticsByAgreedVolumeListPanel />
          </SearchFilterSelectorProvider>
        }
      />
      <Route path={"/advanced"} element={<StatisticsByAdvancedListPanel />} />
    </Route>
  </Routes>
);
